// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"405":"ca4e0cab05a790ff808f","796":"19d8f3b866b433ad8f5d"}[chunkId] + ".js";
};